import store from '../store/store';
import TranslationSettings from '../store/schema/TranslationSettings';
import TranslationMode from '../store/schema/TranslationMode';
import updateTranslationSettings from './updateTranslationSettings';

export default async function updateTranslationMode(mode: TranslationMode) {
    const newSettings: TranslationSettings = {
        translationMode: mode,
        targetLanguage: store.settings.targetLanguage,
        excludedLanguages: [...store.settings.excludedLanguages],
        initialized: true,
    };

    await updateTranslationSettings(newSettings);
}
